import React from 'react';

export default (props) => (
	<aside className='main-sidebar'>
		<section className='sidebar'>

			<ul className='sidebar-menu'>
				{/* Items do menu */}
				{props.children}
			</ul>

		</section>
	</aside>
);



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/template/sidebar/SideBar.jsx